<template>
<div>
    <div class="d-flex">
        <div class="col-md-4">
            <label class="label-search"><small class="text-danger">*</small> Tipo de passagem:</label>
            <div class="input-group">
                <span class="input-group-addon"><i class="fas fa-plane"></i></span>
                <b-form-select @change="verificarTypeFly" v-model="form.tipoPassagemVoo.value">
                <template slot="first">
                    <option :value="null">Selecione</option>
                </template>
                    <option :value="1">SOMENTE IDA</option>
                    <option :value="2">IDA/VOLTA</option>
                </b-form-select>
            </div>
        </div>
        <div class="col-md-2">
            <label class="label-search"><small v-show="form.dataInicioVoo.required" class="text-danger">*</small> Saída:</label>
            <div class="input-group">
                <datepicker name="txtDateStart" v-model="form.dataInicioVoo.value"
                    :format="'dd/MM/yyyy'"
                    :language="ptBR"
                    :placeholder="$lang.Common.DatePlaceholder"
                    :clear-button="true"
                    :clear-button-icon="'fa fa-close'"
                    :calendar-button="true"
                    :calendar-button-icon="'fa fa-calendar'"
                    :bootstrap-styling="true"
                    :full-month-name="true"
                    :use-utc="true"/>
            </div>
        </div>
        <div class="col-md-2" v-show="!disableReturn">
            <label class="label-search"><small v-show="form.dataFimVoo.required" class="text-danger">*</small> Retorno:</label>
            <div class="input-group">
                <datepicker name="txtDateStart" v-model="form.dataFimVoo.value"
                    :format="'dd/MM/yyyy'"
                    :language="ptBR"
                    v-show="!disableReturn"
                    :placeholder="$lang.Common.DatePlaceholder"
                    :clear-button="true"
                    :clear-button-icon="'fa fa-close'"
                    :calendar-button="true"
                    :calendar-button-icon="'fa fa-calendar'"
                    :bootstrap-styling="true"
                    :full-month-name="true"
                    :use-utc="true"/>
            </div>
        </div>
        <div class="col-md-4">
            <label class="label-search"><small class="text-danger">*</small> Pais / Estado / Cidade Origem:</label>
            <div class="input-group">
                <b-form-select v-model="form.paisOrigemFlyID.value"  style="max-width: 180px;margin-right: 2px" @change="onChangeCountryStart">
                    <template slot="first">
                        <option :value="null">selecione</option>
                    </template>
                    <option v-for="data in form.paisOrigemFlyID.options" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
                <b-form-select v-model="form.estadoOrigemFlyID.value"  style="max-width: 110px;margin-right: 2px" @change="onChangeStateStart">
                    <template slot="first">
                        <option :value="null">selecione</option>
                    </template>
                    <option v-for="data in form.estadoOrigemFlyID.options" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
                <b-form-select v-model="form.cidadeOrigemFlyId.value"  >
                    <template slot="first">
                        <option :value="null">selecione</option>
                    </template>
                    <option v-for="data in form.cidadeOrigemFlyId.options" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
            </div>
        </div>
    </div>
    <div class="d-flex">
        <div class="col-md-2">
             <label class="label-search" for="txtCodePeople"><small v-show="form.dataDespesa.required" class="text-danger">*</small> Data despesa:</label>
            <div class="input-group">
                <datepicker name="datadespesa" v-model="form.dataDespesa.value"
                    :format="'dd/MM/yyyy'"
                    :language="ptBR"
                    :placeholder="$lang.Common.DatePlaceholder"
                    :clear-button="true"
                    :clear-button-icon="'fa fa-close'"
                    :calendar-button="true"
                    :calendar-button-icon="'fa fa-calendar'"
                    :bootstrap-styling="true"
                    :full-month-name="true"
                    :use-utc="true"/>
            </div>
        </div>
        <div class="col-md-2">
            <label class="label-search" for="txtGroupsName"><small class="text-danger">*</small> Quantidade:</label>
            <div class="input-group">
                <span class="input-group-addon"><i class="fas fa-calculator"></i></span>
                <money class="form-control form-control-10 text-right"
                v-bind="integerFormat"
                placeholder="0"
                v-model="form.quantidade.value"
                :size="form.quantidade.maxlength"
                :state="form.quantidade.state"
                :required="form.quantidade.required"/>
            </div>
        </div>
        <div class="col-md-4">
            <label class="label-search"><small class="text-danger">*</small> Pais / Estado / Cidade Destino:</label>
            <div class="input-group">
                <b-form-select v-model="form.paisDestinoFlyID.value"  style="max-width: 180px;margin-right: 2px" @change="onChangeCountryEnd">
                    <template slot="first">
                        <option :value="null">selecione</option>
                    </template>
                    <option v-for="data in form.paisDestinoFlyID.options" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
                <b-form-select v-model="form.estadoDestinoFlyID.value"  style="max-width: 110px;margin-right: 2px" @change="onChangeStateEnd">
                    <template slot="first">
                        <option  :value="null">selecione</option>
                    </template>
                    <option v-for="data in form.estadoDestinoFlyID.options" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
                <b-form-select v-model="form.cidadeDestinoFlyId.value">
                    <template slot="first">
                        <option :value="null">selecione Cidade</option>
                    </template>
                     <option v-for="data in form.cidadeDestinoFlyId.options" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
            </div>
        </div>
        <div class="col-md-3">
            <label class="label-search">*O trecho todo será realizado por via aérea?:</label>
            <b-form-checkbox v-model="form.somenteArea.value" class="switch-cus" switch size="lg"></b-form-checkbox>
        </div>
    </div>
    <div class="d-flex mt-4">
        <div class="col-md-12">
            <label class="label-search">Observações:</label>
            <textarea class="form-control" v-model="form.observacao.value"></textarea>
        </div>
    </div>
</div>
</template>

<script>
import TravelAirPlaneModal from './TravelAirPlaneModal'
export default TravelAirPlaneModal
</script>

<style scoped>
.label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 30px;
    font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/TravelAirPlaneModal/TravelAirPlaneModal.vue